import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FormSection } from "./FormSection";
import { HInput, HRadio } from "../../../../validation/HForm";

const MonthlyPaymentSection = ({
  questionNumber,
  title,
  description,
  label,
  radioName,
  paymentName,
}) => {
  const { control } = useFormContext();
  const radioValue = useWatch({ control, name: radioName });
  const showPaymentField = radioValue === "Да";

  return (
    <FormSection
      questionNumber={questionNumber}
      title={title}
      description={description}
    >
      <div className="d-flex columns-2">
        <HRadio
          labels={["Да", "Нет"]}
          name={radioName}
          checkboxStyle={true}
          pillboxStyle={true}
        />
      </div>

      {showPaymentField && (
        <div>
          {label && <label className="form-element-label">{label}</label>}
          <div>
            <HInput
              className="input fullwidth"
              type="text"
              name={paymentName}
              autoComplete="off"
              decimals={2}
              placeholder=".руб"
            />
          </div>
        </div>
      )}
    </FormSection>
  );
};

export default MonthlyPaymentSection;
